<template>
  <body>
    <div id="app">
      <div id="wrapper">
        <div id="sidebar">
          <button @click="composeMail" class="button">Compose</button>
          <ul>
            <li v-for="folder in folders" :key="folder">
              <a href="#" @click.prevent="changeFolder(folder)">{{ folder }}</a>
            </li>
            <li>
              <a href="#" @click.prevent="logout()">Logout</a>
            </li>
          </ul>
        </div>
        <div id="content">
          <ul id="mailList">
            <li v-for="mail in currentMails" :key="mail.id" @click="showMail(mail)">
              <strong>{{ mail.sender }}</strong><br>{{ mail.subject }}
            </li>
          </ul>
          <div v-if="selectedMail">
            <h2>{{ selectedMail.subject }}</h2>
            <p>
            <div v-html="selectedMail.content">
            </div>
            </p>
          </div>
        </div>
        <div style="clear: both;"></div>
      </div>
    </div>
  </body>
</template>

<style></style>


<script>
import axios from "axios";
export default {
  name: "setupGame",
  props: {
    language: Object,
  },
  data() {
    return {
      folders: ["Inbox", "Sent Mail", "Drafts", "Spam"],
      mails: [
        {
          id: 1,
          folder: "Inbox",
          sender: "Becky",
          subject: "Lunch NG",
          content:
            "<p>Hey Melissa!</p><p>I cannot believe you’re going on holiday to Cuba! So jealous! Take me with you!</p><p>Anyway, see you when you’re back! Let’s make sure to grab lunch and you can show me your holiday pics! </p><p>Becky x</p>",
        },
        {
          id: 2,
          folder: "Inbox",
          sender: "Info",
          subject: "Voicemail",
          content:
            '<p>Hello</p><p>Thanks for registering for your new home voicemail system.</p><p>Username: 8743</p><p>Your level of subscription is our premium tier which gives you the ultimate level of service.</p><p>The latest feature of this service is everytime you receive a voicemail at home, we email you an attachment of the audio.</p><p>Please open the attachment to listen to your voicemail.</p><br><br><p><a href="https://assets.thecodfathergame.com/codfatherVoicemailV2.mp3" target="_blank" style="text-decoration: none; color: #0066cc;">📎 Voicemail_Recording.mp3</a></p><p>Any problems please contact our customer support team at info@voicemailsystem.com</p>',
        },
        {
          id: 3,
          folder: "Inbox",
          sender: "Dad",
          subject: "Did you get this?",
          content:
            "<p>Hi Melissa,</p><p>Hope you’re okay and having a great day at work?</p><p>Can you let me know if you’ve received this? I have no idea if I&#39;m sending the email correctly. You know what I’m like...and your mum isn’t too up to speed with this internet malarkey either! </p><p>Anyway! Here is the information you asked me to text you about your Bank details.</p><p>Honestly Melissa I wish you were more organised!</p></p><p>Sort Code 102983, Account number 29340184, Last 3 digits, 102, 16 digit card number 1864810985639186 and the code they sent was 9152. </p><p>Oh…and don’t forget to let your mum know if you’re coming for a roast this Sunday! We're off out now to see your Aunty Joan</p><p>Lots of love and squishees! </p><p>Poppa bear x</p>",
        },
        {
          id: 4,
          folder: "Inbox",
          sender: "Apple",
          subject: "Ted Lasso",
          content:
            "<p>Hi Melissa</p><p>Update from Apple TV, the new series of Ted Lasso has dropped on Apple TV! Don’t forget to set up your reminders on your profile to get access to the latest updates! </p><p>You can do this by logging into your account. </p><p>Apple will never ask you to click on any links.</p>",
        },
        {
          id: 5,
          folder: "Inbox",
          sender: "Fines@govermment.org.com",
          subject: "URGENT!",
          content:
            " <header> <h1 style='background: #50b3a2; color: white; text- align: center; padding: 1em; '>His Majestys Revenue and Customs (HMCR)</h1> </header> <p>Dear Name,</p> <p>We are writing to infrim you of an unclaimed tax rebate currently listed under your name, awaiting confirmation from the rightful recipient.</p> <p><b>Rebate Amount:</b> $5,200.00 GBP</p> <p><b>Reference Code:</b> HMCR2023RBT001</p> <p>To claim your tax rebate, please click the secured link below and follow the provided instructions promptly:</p> <p><a href='#'>http://HMCR.govermment.org.com</a></p> <p>Please note, this link is unique to you and will expire 72 hours from the receipt of this email.</p> <p> An attachment is attached please click <a href='#'>here to download it</a></P </p> <p>Your privacy is paramount, and we urge you to ensure that you are on a secure and private network while processing your claim. If you require further assistance or have any inquiries, reply to this email: support@HMCR-gov-uk-rebateclaim.com </p> <p>Kind Regards,</p> <p>John Smith<br>HMCR Rebate Department<br>London, United Kingdom</p>",
        },
        {
          id: 10,
          folder: "Sent Mail",
          sender: "You",
          subject: "Re: Hello",
          content: "Hello back to you!",
        },
        //... add more sample mails as needed
      ],
      currentFolder: "Inbox",
      selectedMail: null,
    };
  },
  computed: {
    currentMails() {
      return this.mails.filter((mail) => mail.folder === this.currentFolder);
    },
  },
  async mounted() {
    this.selectedMail = this.mails[0];
  },
  methods: {
    composeMail() {
      alert(
        "Please email Melissa's work email from your National Grid email address"
      );
    },
    changeFolder(folder) {
      console.log(folder);
      this.currentFolder = folder;
      this.selectedMail = null;
    },
    showMail(mail) {
      console.log(mail);
      this.selectedMail = mail;
    },
    logout() {
      localStorage.removeItem("emailOK");
      this.$emit("gotoLogin", "");
    },
  },
};
</script>


